module.exports = __webpack_public_path__ + "img/IMG_2368_L_Black.dfadd572.jpg";